import { batch } from 'react-redux';
import { get, isEmpty, orderBy } from 'lodash';
import template from 'url-template';

import awsHeader from '../helpers/awsAuth';
import { getErrorMessage } from '../helpers/errors';
import { handleNetworkError } from './applicationMessageActions';
import { fetchAttributes } from './attributeManagementActions';
import k2aBaseApi from '../apis/key2act';

import {
    SENSOR_TYPES_LOAD_BEGIN,
    SENSOR_TYPES_LOAD_END,
    SENSOR_TYPES_LOAD_ERROR,
    FETCH_SENSOR_TYPES
} from '../actions/actionTypes';

const DEFAULT_LIMIT = 10000;
const AttributeLookupUrl = template.parse('/companies/{companyId}/attributes/{attributeId}/lookups');

export const fetchSensorTypes = (options = {}) => async (dispatch, getState) => {
    options.limit || (options.limit = DEFAULT_LIMIT);
    try {
        const header = await awsHeader();

        dispatch(beginLoading());


        if (isEmpty(getState().attributeManagement.attributes)) {
            await dispatch(fetchAttributes());
        }

        const companyId = getState().companyInfo.companyId;
        const attributes = getState().attributeManagement.attributes;

        const sensorTypeAttribute = attributes.find(item => item.name === 'sensorType');

        const response = await k2aBaseApi.get(
            AttributeLookupUrl.expand({
                companyId,
                attributeId: sensorTypeAttribute.id,
                ...options
            }),
            header
        );

        let formattedPayload = [];

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            formattedPayload.push({
                id:   item.id,
                name: item.value
            });
        });


        const data = [
            {
                items:     orderBy([...formattedPayload], 'name', 'asc'),
                name:      'Sensor Types',
                itemProps: {
                    type: 'sensorTypes'
                }
            }
        ];

        dispatch({
            type:    FETCH_SENSOR_TYPES,
            payload: data
        });
    } catch (error) {
        batch(() => {
            dispatch(errorLoading(getErrorMessage(error)));
            dispatch(handleNetworkError(error));
        });
    } finally {
        dispatch(endLoading());
    }
};

const beginLoading = () => ({
    type:    SENSOR_TYPES_LOAD_BEGIN,
    payload: null
});

const endLoading = () => ({
    type:    SENSOR_TYPES_LOAD_END,
    payload: null
});

const errorLoading = (error) => ({
    type:    SENSOR_TYPES_LOAD_ERROR,
    payload: error
});
